import __vue_component__ from './UserEditableRendererEnriched.vue.js';

//
var script = {
  name: 'UserRendererEnriched',
  components: {
    UserEditableRendererEnriched: __vue_component__
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    avatarOnly: {
      type: Boolean,
      default: false
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/UserRendererEnriched.vue_rollup-plugin-vue=script.js